module.exports = "https://static.zego.com/_next/static/images/hero-private-hire-v3-0a370c75097b6f4dfe7e3f490eaa8077.jpg";